import {Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit} from "@angular/core";
import {UntypedFormControl, Validators} from "@angular/forms";
import {Answer} from "../../../../swaggerServices";
import {IFormField} from "../form-field-wrapper/form-field-wrapper.component";

@Component({
    selector: "app-text-area",
    templateUrl: "./text-area.component.html",
    styleUrls: ["./text-area.component.scss"],
    standalone: false
})
export class TextAreaComponent implements OnInit, AfterViewInit {
  @Input() question: IFormField;
  @Input() myFormControl: UntypedFormControl;
  @Input() disabled?: boolean;
  @Input() autofocus: boolean = false;
  @Input() tabIndex?: number = 0;
  @Output() answer: [Answer];
  @Output() blur = new EventEmitter()
  isFocused: boolean; // whether input is in focus

  @ViewChild('inputEl') inputEl: ElementRef;
  constructor() {
  }

  ngOnInit() {
  }
  ngAfterViewInit() {
    if (this.autofocus) {
      this.inputEl.nativeElement.focus();
    }
  }
  
  onBlur() {
    this.blur.emit();
    this.isFocused = false;
  }
}
